import('./style/library_modules/css-normalize/_css-normalize.css');
import('./style/main.scss');

import('./index.html');

import('./script/main.js');
